import React from "react";
import "./css/Feature4.css";

export default function Feature4() {
  return (
    <section className="container">
    <p className="Feature4">Text flow color background example.</p>
    </section>
  );
}


